/* eslint-disable @typescript-eslint/no-unnecessary-condition */
import type { Partner } from '@oneaudi/audi-partner-utils/lib/types';
import { createDirectionsLink, createMyAudiLink } from './PartnerLinks';

export type PbcPartner = {
  partnerId: string;
  officialName: string;
  nonOfficialName: string;
  locationName?: string | null;
  address: string[];
  phone?: string | null;
  fax?: string;
  url?: string | null;
  email?: string | null;
  locationImageUrl: string;
  vCardUrl: string;
  myAudiUrl: string | undefined;
  directionsUrl: string;
  services: string[];
  additionalServices?: string[];
  openingHours?: PartnerOpeningHours | null;
  long?: number;
  lat?: number;
  nameEnhanced: string; // TODO: Remove and utilise names above
};

export type PbcDataPartner = {
  name?: string | null;
  partnerId: string;
  displayName?: string | null;
  officialName: string;
  nonOfficialName: string;
  locationName?: string | null;
  address: string[];
  street?: string | null;
  city?: string | null;
  zipCode?: string | null;
  region?: string | null;
  country?: string | null;
  phone?: string | null;
  fax?: string;
  url?: string | null;
  email?: string | null;
  vCardUrl: string;
  myAudiUrl: string | undefined;
  directionsUrl: string;
  services: string[];
  additionalServices?: string[];
  openingHours?: PartnerOpeningHours | null;
  longitude?: number;
  latitude?: number;
  nameEnhanced: string;
  additionalData: {
    locationImage: string;
    displayName?: string;
  };
};

export type PartnerOpeningHours = {
  openingHoursNote?: string;
  departments: DepartmentOpeningHours[];
};

export type DepartmentOpeningHours = {
  id?: string;
  departmentName: string;
  departmentOpeningHoursNote?: string;
  openingHours: DayOpeningHours[];
};

export type DayOpeningHours = {
  id: WeekDay;
  open: boolean;
  timeRanges?: TimeRange[];
};

export type TimeRange = {
  openTime?: string;
  closeTime?: string;
};

export type WeekDay =
  | 'monday'
  | 'tuesday'
  | 'wednesday'
  | 'thursday'
  | 'friday'
  | 'saturday'
  | 'sunday';

export const createPartner = (data: Partner | undefined): PbcPartner | undefined => {
  if (!data) {
    return undefined;
  }

  const displayName = (data as Partner & { displayName?: string | null })?.displayName;
  const preferredDisplayName = displayName || data?.additionalData?.displayName || '';

  let nameEnhanced: string = data?.name || preferredDisplayName;

  if (data?.additionalData && data?.additionalData?.locationName) {
    nameEnhanced += ` ${data?.additionalData.locationName}`;
  }

  const officialName = `${preferredDisplayName || data?.name || ''} ${
    data?.additionalData?.locationName || ''
  }`;
  const nonOfficialName = `${data?.name || ''} ${data?.additionalData?.locationName || ''}`;

  return {
    partnerId: data && data?.dealerId,
    officialName,
    nonOfficialName,
    locationName: data?.additionalData?.locationName,
    address: data?.address,
    phone: data?.phone,
    url: data?.additionalData?.additionalUrl || data.url,
    email: data && data.email,
    locationImageUrl: data?.additionalData?.locationImage || '',
    vCardUrl: data?.vCardUrl || '',
    myAudiUrl: createMyAudiLink(data),
    directionsUrl: createDirectionsLink(data),
    services: data?.services,
    additionalServices: data?.additionalData?.additionalServices || [],
    openingHours: data && (data.openingHours as PartnerOpeningHours),
    long: data?.longitude,
    lat: data?.latitude,
    nameEnhanced,
  };
};
